<template>
  <div class="employee-warning-banner">
    <i class="icon sm rhg-font-icon--calendar"></i>
    <div
      data-testid="employee-warning-banner-text"
      class="employee-warning-banner__text"
      v-html="translate('rdMemberNotificationTeamRateEmployee')"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'EmployeeWarningBanner'
}
</script>

<style lang="scss" scoped>
.employee-warning-banner {
  display: flex;
  align-items: center;
  background-color: #dbe3ec;
  padding: 12px;
  border-radius: 8px;
  width: 100%;

  @media (max-width: 992px) {
    margin: 20px 12px 0px 12px;
    align-items: start;
    width: fit-content;
  }

  &__text {
    padding-inline: 8px;
    font-size: 14px;

    :deep(b) {
      font-weight: bold !important;
    }
  }
}
</style>
